module.exports = __webpack_public_path__ + "img/order_header_bg.013d9aaf.png";